import * as Yup from "yup";

export const LoginValidation = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});

export const DeleteProperty = (itemName) =>
  Yup.object({
    confirmation: Yup.string()
      .required(`Please enter "${itemName}"`)
      .oneOf([itemName], "The enter correct name"),
  });

export const CodeValidationSchema = (type) =>
  Yup.object({
    verificationCode: Yup.number()
      .max(6, `${type === "2FA" ? "Code" : "Otp"} should be of 6 numbers`)
      .required(
        `Enter ${type === "2FA" ? "Authentication" : "Verification"} Code`
      ),
  });

export const profileSettingSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"), // Optional
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: Yup.string()
    .transform((value) => value.replace(/\D/g, ""))
    .test("starts-with-1", "Phone number must start with +1", (value) => {
      return value.startsWith("1");
    })
    .test(
      "length",
      "Phone number must be 11 digits long including country code",
      (value) => {
        return value.length === 11;
      }
    )
    .required("Phone number is required")
    .matches(/^1\d{10}$/, "Invalid format"), // Optional
  streetAddress: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.string()
    .matches(/^[0-9]{5}$/, "Zip code must be 5 digits")
    .required("Zip is required"),
  profileImage: Yup.mixed().nullable(), // Optional
});

export const SecuritySettingsSchema = Yup.object().shape({
  is2FA: Yup.boolean().default(false),
  currentPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Current Password must contain at least one special character"
    )
    .required("Current Password is required"),
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "New Password must contain at least one special character"
    )
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

export const NotificationSettingSchema = Yup.object().shape({
  isPushNotification: Yup.boolean().default(false),
  isNotificationSound: Yup.boolean().default(false),
  isEmailNotification: Yup.boolean().default(false),
});

export const replyValidationSchema = Yup.object({
  message: Yup.string()
    .required("Reply message is required")
    .min(1, "Message cannot be empty"),
  isNote: Yup.boolean(),
});

export const snoozeValidationSchema = Yup.object({
  snoozeDate: Yup.date()
    .required("Snooze date is required")
    .min(new Date(), "Date must be in the future"),
  snoozeTime: Yup.string(),
});